
import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import VideoBufferRegionSelectorController from "controllers/audioEditor/VideoBufferRegionSelectorController";
import SelectVideoRegionPopupView from "views/audioEditor/SelectVideoRegionPopupView";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import PlayerService from "services/PlayerService";
import PersistentModels from "services/PersistentModels";
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import PlaylistHelper from "models/helper/PlaylistHelper";
import TrebbleAudio from "models/TrebbleAudio";
import FileUploadHelper from "models/helper/FileUploadHelper";
import RolloutHelper from "models/helper/FeatureRolloutHelper";
import TrebbleBackgroundMusicStoreHelper from "models/helper/TrebbleBackgroundMusicStoreHelper";
import ti18n from "i18n!nls/ConfigureBackgroundMusici18n";
import Utils from "models/helper/Utils";
import RSVP from "rsvp";

const Rollout = RolloutHelper.getInstance();

const SelectVideoRegionPopupController = Chaplin.Controller.extend({

			initialize : function(options) {
				_.extend(this, Backbone.Events);
				this._videoSegmentJson = options.videoSegmentJson;
				this._videoUniqueId = options.videoUniqueId;
				this._videoType = options.videoType;
				this._sequencerSettings = options.sequencerSettings;
				this._onRegionUpdated = options.onRegionUpdated;
				this._onRegionNotUpdated = options.onRegionNotUpdated;
				this._saveButtonWasClicked = false;

			},


			getModel : function() {
				return this.model;
			},

			getView : function() {
				return this.view;
			},

			onPopupClosed : function(){
				if(this._saveButtonWasClicked){
					if(this._onRegionUpdated){
						this._onRegionUpdated(this.videoBufferRegionSelectorController ? this.videoBufferRegionSelectorController.getStartTime(): null, this.videoBufferRegionSelectorController ? this.videoBufferRegionSelectorController.getEndTime(): null);
					}
				}else{
					if(this._onRegionNotUpdated){
						this._onRegionNotUpdated();
					}
				}
				if(this.videoBufferRegionSelectorController){
					this.videoBufferRegionSelectorController.getView().destroy();
				}

			},


			onRegionChangeSaved : function(){
				this._saveButtonWasClicked = true;
				this.view.close();
			},

			_buildVideoBufferRegionSelectorController : function(){
				const params  = {
					"videoSegmentJson": this._videoSegmentJson,
					"sequencerSettings": this._sequencerSettings,
					"onRegionChangeSaved": this.onRegionChangeSaved.bind(this),
					"videoUniqueId": this._videoUniqueId,
					"videoType": this._videoType
				};
				const videoBufferRegionSelectorController = new VideoBufferRegionSelectorController(params);
				this.videoBufferRegionSelectorController = videoBufferRegionSelectorController;
				return this.videoBufferRegionSelectorController.buildModelAndRenderView();
			},

			_onSaveTrimButtonClicked : function(){

			},


			buildModelAndRenderView : function() {
				const promises = [];
				promises.push(this._buildVideoBufferRegionSelectorController());

				return RSVP.Promise.all(promises).then((function(){
					const params = {};
					params.videoBufferRegionSelectorView = this.videoBufferRegionSelectorController.getView();
					this.view = new SelectVideoRegionPopupView(params);
					this.listenTo(this.view, "closed", this.onPopupClosed);

					this.view.render();

				}).bind(this))


			}

});

export default SelectVideoRegionPopupController;
